import { render, staticRenderFns } from "./StreamingNewWebRTCPlayer.vue?vue&type=template&id=66fd3b00&scoped=true"
import script from "./StreamingNewWebRTCPlayer.vue?vue&type=script&lang=js"
export * from "./StreamingNewWebRTCPlayer.vue?vue&type=script&lang=js"
import style0 from "./StreamingNewWebRTCPlayer.vue?vue&type=style&index=0&id=66fd3b00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd3b00",
  null
  
)

export default component.exports